// /* eslint-disable no-unused-vars */
// import {
//     Flex,
//     HStack,
//     Image,
//     Text,
//     VStack,
//     Button,
//     Input,
//     Select,
//     Box,
//     Radio,
//     RadioGroup,
//     Stack,
// } from '@chakra-ui/react';
// import React, { useEffect, useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { ProfileConatiner } from '../../../components/LandingPageComponents/styles/SplashStyles';
// import { backbtn } from './Icons';
// import ImagePlaceholder from '../../../assets/ImagePlaceholder.jpg';
// import axios from 'axios';
// import { update_profile } from '../../../redux/actions/profileActions';
// import { useDispatch, useSelector } from 'react-redux';
// import { Backbutton } from 'components/LandingPageComponents/styles/HeaderStyles';
// import {
//     useGetCitiesByStateId,
//     useGetCountries,
//     useGetStatesByCountryId,
// } from 'hooks/useGetLocations';
// import useGetUserDetails from 'hooks/useGetUserDetail';
// import { transformAuthUser } from 'utils/utils';
// import { setCurrenciesRates, setCurrencyValue } from 'redux/actions/currencyActions';

// const UserProfile = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const dispatch = useDispatch();
//     const userLocationReducer = useSelector((state) => state.userLocationReducer);
//     const verifyReducer = useSelector((state) => state.verifyReducer);
//     const profileReducer = useSelector((state) => state.profileReducer);
//     const refreshTokenReducer = useSelector((state) => state.refreshTokenReducer);
//     const currency = useSelector((state) => state.currencyReducer.currenciesRates);
//     const { token } = refreshTokenReducer;

//     let title = location.pathname;
//     var array = title.split('/');

//     const { country } = userLocationReducer;
//     const { verifiedUser } = verifyReducer;
//     const { from, user } = profileReducer;

//     const { flattenedUser } = useGetUserDetails();
//     const details = flattenedUser?.attributes;
//     const userDetails = transformAuthUser(user?.data?.user);

//     useEffect(() => {
//         if (from === 'user') {
//             navigate('/dashboard/settings');
//         }
//     }, [from, navigate]);

//     const [profileImage, setProfileImage] = useState(
//         userDetails?.attributes?.user_imgage ||
//             details?.user_information?.user_imgage ||
//             details?.user_imgage ||
//             '',
//     );
//     const [firstName, setFirstName] = useState(
//         details?.user_information?.first_name || details?.first_name || '',
//     );
//     const [lastName, setLastName] = useState(
//         details?.user_information?.last_name || details?.last_name || '',
//     );
//     const [middleName, setMiddleName] = useState(
//         details?.user_information?.middle_name || details?.middle_name || '',
//     );
//     const [phone, setPhone] = useState(
//         details?.user_information?.phone || details?.phone || flattenedUser?.phone || '',
//     );
//     const [address, setAddress] = useState(
//         details?.user_information?.address || details?.address || '',
//     );
//     const [dateOfBirth, setDateOfBirth] = useState(
//         details?.user_information?.date_of_birth || details?.date_of_birth || '',
//     );
//     const [gender, setGender] = useState(
//         details?.user_information?.gender || details?.gender || '',
//     );
//     const [userlocation, setUserLocation] = useState(country);
//     const [language, setLanguage] = useState('English');
//     const [isSaving, setIsSaving] = useState(false);
//     const [selectedLocations, setSelectedLocations] = useState({
//         country: userlocation ?? null,
//         state: details?.user_information?.state || details?.state || null,
//         city: details?.user_information?.city || details?.city || null,
//     });

//     const countries = useGetCountries();

//     const states = useGetStatesByCountryId(
//         countries?.find((item) => item.name === selectedLocations?.country)?.isoCode,
//     );
//     const cities = useGetCitiesByStateId(
//         states?.find((item) => item.name === selectedLocations?.state)?.isoCode,
//         countries?.find((item) => item.name === selectedLocations?.country)?.isoCode,
//     );

//     //handle click of button to trigger file upload
//     const hiddenFileInput = React.useRef(null);
//     const handleClick = (event) => {
//         hiddenFileInput.current.click();
//     };

//     //function to handle file uploade
//     const handleFileUpload = (event) => {
//         // const fileUploaded = event.target.files[0];
//         const formData = new FormData();
//         formData.append('file', event.target.files[0]);
//         formData.append('upload_preset', 'o5dxfulx');
//         axios
//             .post('https://api.cloudinary.com/v1_1/tajiri/image/upload', formData)
//             .then((response) => {
//                 setProfileImage(response?.data?.url);
//             });
//     };
//     const currencies = useSelector((state) => state.currencyReducer.currencies);

//     //handle submit of form and moving to next page
//     const handleProceed = () => {
//         setIsSaving(true);

//         const data = {
//             first_name: firstName,
//             last_name: lastName,
//             middle_name: middleName,
//             location: userlocation,
//             language: language,
//             phone,
//             address,
//             country: userlocation,
//             state: selectedLocations?.state,
//             city: selectedLocations?.city,
//             user_imgage: profileImage,
//             currency: currency?.symbol,
//             date_of_birth: dateOfBirth,
//             gender: gender,
//         };
//         let fro = 'user';
//         dispatch(update_profile(data, fro));

//         // Reset saving state after a delay
//         setTimeout(() => {
//             setIsSaving(false);
//         }, 2000);
//     };

//     const handleCurrencyChange = (e) => {
//         dispatch(setCurrencyValue(e.target.value));
//         const currencyRates = currencies?.find((currency) => currency.symbol === e.target.value);
//         if (currencyRates) {
//             dispatch(setCurrenciesRates(currencyRates));
//             const data = {
//                 currency: currencyRates.symbol,
//             };
//         }
//     };

//     return (
//         <ProfileConatiner>
//             <HStack justify="start" alignItems="center" display={'flex'}>
//                 <Backbutton onClick={() => navigate(-1)}>{backbtn}</Backbutton>
//                 <div className="menuSection">
//                     <Text fontSize="18px">
//                         {array[array.length - 1] === 'user' && 'Personal Profile'}
//                     </Text>
//                 </div>
//                 <div></div>
//             </HStack>

//             <Flex w="full" h="full" justify="center" alignItems="center" flexDir="column">
//                 <VStack mt="30px">
//                     <Text textAlign="center" fontSize="14px" mb="10px">
//                         Your Agent ID <br />
//                         <b>{details?.agent_id || 'TAJ-4626'}</b>
//                     </Text>
//                     <Image
//                         src={profileImage || ImagePlaceholder}
//                         w="64px"
//                         h="64px"
//                         borderRadius="50%"
//                         objectFit="cover"
//                     />
//                     <Button
//                         bg="#E7E7FF"
//                         borderRadius="48px"
//                         py="8px"
//                         px="16px"
//                         h="32px"
//                         color="#1b3b5f"
//                         onClick={handleClick}
//                         fontWeight="500"
//                         _hover={{ bg: '#d0d0ff' }}
//                         fontSize="13px">
//                         Upload Photo
//                     </Button>
//                     <Input
//                         type="file"
//                         ref={hiddenFileInput}
//                         onChange={handleFileUpload}
//                         accept="image/*"
//                         style={{ display: 'none' }}
//                     />
//                 </VStack>

//                 <VStack
//                     mt="40px"
//                     w="full"
//                     justifyContent="space-between"
//                     alignItems="self-start"
//                     spacing={0}>
//                     <Flex
//                         w="full"
//                         justifyContent="space-between"
//                         pl="5px"
//                         py={{ base: '20px', lg: '10px' }}
//                         className="noTop"
//                         borderTop="1px solid #f2f4f5">
//                         <Text fontSize="16px" color="#090A0A">
//                             Account Type
//                         </Text>
//                         <Text fontSize="16px">{details?.account_types ?? 'N/A'}</Text>
//                     </Flex>

//                     <Text
//                         w="full"
//                         pt={{ base: '20px', lg: '15px' }}
//                         pb="12px"
//                         pl="5px"
//                         bg="#F7F9FA"
//                         color="#6C7072"
//                         fontSize="12px"
//                         fontWeight="600">
//                         PERSONAL INFORMATION
//                     </Text>

//                     <Flex
//                         w="full"
//                         justifyContent="space-between"
//                         pl="5px"
//                         py={{ base: '20px', lg: '10px' }}
//                         borderTop="1px solid #f2f4f5">
//                         <Text fontSize="16px" color="#090A0A">
//                             First Name
//                         </Text>
//                         <Input
//                             w="45%"
//                             textAlign="right"
//                             type="text"
//                             placeholder="enter first name"
//                             variant="unstyled"
//                             name="firstName"
//                             value={firstName}
//                             onChange={(e) => {
//                                 setFirstName(e.target.value);
//                             }}
//                         />
//                     </Flex>

//                     <Flex
//                         w="full"
//                         justifyContent="space-between"
//                         pl="5px"
//                         py={{ base: '20px', lg: '10px' }}
//                         borderTop="1px solid #f2f4f5">
//                         <Text fontSize="16px" color="#090A0A">
//                             Middle Name
//                         </Text>
//                         <Input
//                             w="45%"
//                             textAlign="right"
//                             type="text"
//                             placeholder="enter middle name"
//                             variant="unstyled"
//                             name="middleName"
//                             value={middleName}
//                             onChange={(e) => {
//                                 setMiddleName(e.target.value);
//                             }}
//                         />
//                     </Flex>

//                     <Flex
//                         w="full"
//                         justifyContent="space-between"
//                         pl="5px"
//                         className="noTop"
//                         py={{ base: '20px', lg: '10px' }}
//                         borderTop="1px solid #f2f4f5">
//                         <Text fontSize="16px" color="#090A0A">
//                             Last Name
//                         </Text>
//                         <Input
//                             w="45%"
//                             textAlign="right"
//                             type="text"
//                             placeholder="enter last name"
//                             variant="unstyled"
//                             name="lastName"
//                             value={lastName}
//                             onChange={(e) => {
//                                 setLastName(e.target.value);
//                             }}
//                         />
//                     </Flex>

//                     <Flex
//                         w="full"
//                         justifyContent="space-between"
//                         pl="5px"
//                         className="noTop"
//                         py={{ base: '20px', lg: '10px' }}
//                         borderTop="1px solid #f2f4f5"
//                         alignItems="center">
//                         <Text fontSize="16px" color="#090A0A">
//                             Gender
//                         </Text>
//                         <RadioGroup onChange={setGender} value={gender}>
//                             <Stack direction="row" spacing={4}>
//                                 <Radio value="Male" colorScheme="blue">
//                                     Male
//                                 </Radio>
//                                 <Radio value="Female" colorScheme="blue">
//                                     Female
//                                 </Radio>
//                             </Stack>
//                         </RadioGroup>
//                     </Flex>

//                     <Flex
//                         w="full"
//                         justifyContent="space-between"
//                         pl="5px"
//                         className="noTop"
//                         py={{ base: '20px', lg: '10px' }}
//                         borderTop="1px solid #f2f4f5">
//                         <Text fontSize="16px" color="#090A0A">
//                             Date of Birth
//                         </Text>
//                         <Input
//                             w="45%"
//                             textAlign="right"
//                             type="date"
//                             placeholder="select date"
//                             variant="unstyled"
//                             value={dateOfBirth}
//                             onChange={(e) => {
//                                 setDateOfBirth(e.target.value);
//                             }}
//                         />
//                     </Flex>

//                     <Text
//                         w="full"
//                         pt={{ base: '20px', lg: '15px' }}
//                         pb="12px"
//                         pl="5px"
//                         bg="#F7F9FA"
//                         color="#6C7072"
//                         fontSize="12px"
//                         fontWeight="600">
//                         CONTACT INFORMATION
//                     </Text>

//                     <Flex
//                         w="full"
//                         justifyContent="space-between"
//                         pl="5px"
//                         className="noTop"
//                         py={{ base: '20px', lg: '10px' }}
//                         borderTop="1px solid #f2f4f5">
//                         <Text fontSize="16px" color="#090A0A">
//                             Phone Number
//                         </Text>
//                         <Input
//                             w="45%"
//                             textAlign="right"
//                             type="tel"
//                             inputMode="tel"
//                             placeholder="enter phone number"
//                             variant="unstyled"
//                             value={phone}
//                             onInput={(e) => {
//                                 setPhone(e.target.value);
//                             }}
//                         />
//                     </Flex>

//                     <Flex
//                         w="full"
//                         justifyContent="space-between"
//                         pl="5px"
//                         className="noTop"
//                         py={{ base: '20px', lg: '10px' }}
//                         borderTop="1px solid #f2f4f5">
//                         <Text fontSize="16px" color="#090A0A">
//                             Email
//                         </Text>
//                         <Input
//                             w="45%"
//                             textAlign="right"
//                             type="email"
//                             placeholder="ochije@email.com"
//                             variant="unstyled"
//                             readOnly
//                             value={verifiedUser?.data?.user.email}
//                         />
//                     </Flex>

//                     <Text
//                         w="full"
//                         pt={{ base: '20px', lg: '15px' }}
//                         pb="12px"
//                         pl="5px"
//                         bg="#F7F9FA"
//                         color="#6C7072"
//                         fontSize="12px"
//                         fontWeight="600">
//                         LOCATION DETAILS
//                     </Text>

//                     <Flex
//                         w="full"
//                         justifyContent="space-between"
//                         pl="5px"
//                         className="noTop"
//                         py={{ base: '20px', lg: '10px' }}
//                         borderTop="1px solid #f2f4f5">
//                         <Text fontSize="16px" color="#090A0A">
//                             Country
//                         </Text>
//                         <Select
//                             w="30%"
//                             icon="none"
//                             textAlign="right"
//                             placeholder="Select Country"
//                             value={userlocation}
//                             defaultValue={userlocation}
//                             variant="unstyled"
//                             onChange={(e) => {
//                                 setUserLocation(e.target.value);
//                                 setSelectedLocations({
//                                     ...selectedLocations,
//                                     country: e.target.value,
//                                     state: null,
//                                     city: null,
//                                 });
//                             }}>
//                             {countries.map((country) => (
//                                 <option key={country?._id} value={country?.name}>
//                                     {country?.name}
//                                 </option>
//                             ))}
//                         </Select>
//                     </Flex>

//                     <Flex
//                         w="full"
//                         justifyContent="space-between"
//                         pl="5px"
//                         className="noTop"
//                         py={{ base: '20px', lg: '10px' }}
//                         borderTop="1px solid #f2f4f5">
//                         <Text fontSize="16px" color="#090A0A">
//                             State
//                         </Text>
//                         <Select
//                             w="30%"
//                             icon="none"
//                             textAlign="right"
//                             placeholder="Select state"
//                             variant="unstyled"
//                             value={selectedLocations.state}
//                             onChange={(e) => {
//                                 setSelectedLocations({
//                                     ...selectedLocations,
//                                     state: e.target.value,
//                                     city: null,
//                                 });
//                             }}>
//                             {states.map((state) => (
//                                 <option key={state.name} value={state.name}>
//                                     {state.name}
//                                 </option>
//                             ))}
//                         </Select>
//                     </Flex>

//                     <Flex
//                         w="full"
//                         justifyContent="space-between"
//                         pl="5px"
//                         className="noTop"
//                         py={{ base: '20px', lg: '10px' }}
//                         borderTop="1px solid #f2f4f5">
//                         <Text fontSize="16px" color="#090A0A">
//                             City
//                         </Text>
//                         <Select
//                             w="30%"
//                             icon="none"
//                             textAlign="right"
//                             placeholder="Select City"
//                             variant="unstyled"
//                             value={selectedLocations.city}
//                             onChange={(e) => {
//                                 setSelectedLocations({
//                                     ...selectedLocations,
//                                     city: e.target.value,
//                                 });
//                             }}>
//                             {cities.map((city) => (
//                                 <option key={city.name} value={city.name}>
//                                     {city.name}
//                                 </option>
//                             ))}
//                         </Select>
//                     </Flex>

//                     <Flex
//                         w="full"
//                         justifyContent="space-between"
//                         pl="5px"
//                         className="noTop"
//                         py={{ base: '20px', lg: '10px' }}
//                         borderTop="1px solid #f2f4f5">
//                         <Text fontSize="16px" color="#090A0A">
//                             Address
//                         </Text>
//                         <Input
//                             w="45%"
//                             textAlign="right"
//                             type="text"
//                             placeholder="enter address"
//                             variant="unstyled"
//                             value={address}
//                             onInput={(e) => {
//                                 setAddress(e.target.value);
//                             }}
//                         />
//                     </Flex>

//                     <Text
//                         w="full"
//                         pt={{ base: '20px', lg: '15px' }}
//                         pb="12px"
//                         pl="5px"
//                         bg="#F7F9FA"
//                         color="#6C7072"
//                         fontSize="12px"
//                         fontWeight="600">
//                         INTERNATIONAL PREFERENCES
//                     </Text>

//                     <Flex
//                         w="full"
//                         justifyContent="space-between"
//                         pl="5px"
//                         className="noTop"
//                         py={{ base: '20px', lg: '10px' }}
//                         borderTop="1px solid #f2f4f5">
//                         <Box>
//                             <Text fontSize="16px" color="#090A0A">
//                                 Language
//                             </Text>
//                         </Box>
//                         <Select
//                             w="30%"
//                             icon="none"
//                             value={language}
//                             defaultValue={language}
//                             textAlign="right"
//                             variant="unstyled"
//                             onChange={(e) => {
//                                 setLanguage(e.target.value);
//                             }}>
//                             <option value="English">English</option>
//                             <option value="French">French</option>
//                             <option value="Spanish">Spanish</option>
//                         </Select>
//                     </Flex>

//                     <Flex
//                         w="full"
//                         justifyContent="space-between"
//                         pl="5px"
//                         py={{ base: '20px', lg: '10px' }}
//                         className="noTop"
//                         borderTop="1px solid #f2f4f5">
//                         <Text fontSize="16px" color="#090A0A">
//                             Currency
//                         </Text>
//                         {/* <Text fontSize="16px">{details?.currency ?? 'N/A'}</Text> */}
//                         <Select
//                             border="none"
//                             w={{ lg: '20%' }}
//                             maxHeight={{ ld: '40vh' }}
//                             value={currency?.symbol ?? 'USD'}
//                             onChange={handleCurrencyChange}>
//                             {currencies?.length > 0 &&
//                                 currencies?.map((currency, i) => (
//                                     <option key={i} value={currency.symbol}>
//                                         {currency.symbol}
//                                     </option>
//                                 ))}
//                         </Select>
//                     </Flex>

//                     <Flex mt="24px" w="full" justify="center">
//                         <Button
//                             colorScheme="grey"
//                             bg="#1b3b5f"
//                             color="white"
//                             fontWeight="400"
//                             borderRadius="48px"
//                             fontSize="14px"
//                             px="40px"
//                             onClick={handleProceed}
//                             isLoading={isSaving}
//                             loadingText="Saving..."
//                             isDisabled={isSaving}
//                             _hover={{ bg: '#152d47' }}
//                             _disabled={{ opacity: 0.6, cursor: 'not-allowed' }}>
//                             Save Changes
//                         </Button>
//                     </Flex>
//                 </VStack>
//             </Flex>
//         </ProfileConatiner>
//     );
// };

// export const right = (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M9 18L15 12L9 6"
//             stroke="#090A0A"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//     </svg>
// );

// export default UserProfile;

/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef, useMemo, useCallback, memo } from 'react';
import {
    Box, Flex, HStack, VStack, Text, Heading, Image, Button, Input,
    InputGroup, InputLeftElement, FormControl, FormLabel,
    Radio, RadioGroup, Stack, Icon,
} from '@chakra-ui/react';
import { Formik, useFormikContext } from 'formik';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AiOutlineMail, AiOutlineCamera } from 'react-icons/ai';
import toast from 'react-hot-toast';
import * as Yup from 'yup';
import axios from 'axios';

import CustomSelect from 'components/CustomSelect';
import { update_profile } from '../../../redux/actions/profileActions';
import {
    useGetCitiesByStateId,
    useGetCountries,
    useGetStatesByCountryId,
} from 'hooks/useGetLocations';
import useGetUserDetails from 'hooks/useGetUserDetail';
import { transformAuthUser } from 'utils/utils';
import {
    setCurrenciesRates, setCurrencyValue,
} from 'redux/actions/currencyActions';
import ImagePlaceholder from '../../../assets/ImagePlaceholder.jpg';
import { ProfileConatiner } from '../../../components/LandingPageComponents/styles/SplashStyles';

/* ─────────────────────────────────────────────────────────────
   BRAND TOKENS
   ───────────────────────────────────────────────────────────── */
const NAVY        = '#1B3B5F';
const NAVY_DEEP   = '#0F2940';
const CYAN        = '#DCF8F9';
const INK         = '#1A2740';
const MUTED       = '#5A6B7E';
const FAINT       = '#8896AE';
const SURFACE     = '#FFFFFF';
const SURFACE_ALT = '#F7F9FB';
const BORDER      = '#E8EDF5';
const BORDER_INPUT= '#DCE3EE';
const DANGER      = '#E53E3E';
const SUCCESS     = '#10B981';

const FONT      = "'Bricolage Grotesque', sans-serif";
const SHADOW_SM = '0 1px 3px rgba(27,59,95,0.06)';
const SHADOW_MD = '0 4px 16px rgba(27,59,95,0.08)';

/* ─────────────────────────────────────────────────────────────
   ICONS
   ───────────────────────────────────────────────────────────── */
const BackArrowIcon = (props) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M19 12H5M12 19l-7-7 7-7"
            stroke="currentColor" strokeWidth="2.2"
            strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

/* ─────────────────────────────────────────────────────────────
   VALIDATION SCHEMA
   ───────────────────────────────────────────────────────────── */
const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegExp = /^[0-9+\-\s()]{7,20}$/;

const profileSchema = Yup.object().shape({
    firstName: Yup.string()
        .min(2, 'Must be at least 2 characters')
        .max(50, 'Must not exceed 50 characters')
        .required('First name is required'),
    lastName: Yup.string()
        .min(2, 'Must be at least 2 characters')
        .max(50, 'Must not exceed 50 characters')
        .required('Last name is required'),
    middleName: Yup.string()
        .max(50, 'Must not exceed 50 characters')
        .optional(),
    phone: Yup.string()
        .matches(phoneRegExp, 'Invalid phone number')
        .test(
            'digits-only-length',
            'Phone number must be 7–20 digits',
            (val) => {
                if (!val) return true;
                const digits = val.replace(/\D/g, '');
                return digits.length >= 7 && digits.length <= 20;
            }
        )
        .required('Phone number is required'),
    address: Yup.string().required('Address is required'),
    dateOfBirth: Yup.string().optional(),
    gender: Yup.string().oneOf(['Male', 'Female', ''], 'Invalid gender').optional(),
    country: Yup.string().required('Country is required').nullable(),
    state: Yup.string().required('State is required').nullable(),
    city: Yup.string().required('City is required').nullable(),
    language: Yup.string().required(),
});

/* ─────────────────────────────────────────────────────────────
   DIRTY FORM GUARD — browser-level only (no useBlocker)
   ───────────────────────────────────────────────────────────── */

const DirtyFormGuard = ({ when }) => {
    useEffect(() => {
        if (!when) return undefined;
        const handler = (e) => {
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', handler);
        return () => window.removeEventListener('beforeunload', handler);
    }, [when]);
    return null;
};

/* ─────────────────────────────────────────────────────────────
   REUSABLE FORM PIECES
   ───────────────────────────────────────────────────────────── */

const FieldError = memo(function FieldError({ message }) {
    if (!message) return null;
    return (
        <Text
            mt="4px"
            fontSize="11px"
            color={DANGER}
            fontWeight="500"
            fontFamily={FONT}
            role="alert"
        >
            {message}
        </Text>
    );
});

/* Section header — much tighter than before; just a label + divider */
const SectionHeader = memo(function SectionHeader({ children, isFirst }) {
    return (
        <Box w="full" mt={isFirst ? '0' : '24px'} mb="6px">
            <Text
                color={MUTED}
                fontSize="11px"
                fontWeight="800"
                fontFamily={FONT}
                letterSpacing="0.06em"
                textTransform="uppercase"
            >
                {children}
            </Text>
            <Box mt="6px" h="1px" bg={BORDER} />
        </Box>
    );
});

/* Tighter, denser field row — labels above on mobile, two-col on desktop */
const FieldRow = memo(function FieldRow({ label, helper, error, children }) {
    return (
        <FormControl py="10px">
            <Flex
                direction={{ base: 'column', md: 'row' }}
                gap={{ base: '6px', md: '24px' }}
                align={{ base: 'stretch', md: 'flex-start' }}
            >
                <Box minW={{ md: '180px' }} maxW={{ md: '180px' }} pt={{ md: '8px' }}>
                    <FormLabel
                        mb="0"
                        fontSize="13px"
                        color={INK}
                        fontWeight="600"
                        fontFamily={FONT}
                        lineHeight="1.3"
                    >
                        {label}
                    </FormLabel>
                    {helper && (
                        <Text
                            mt="2px"
                            fontSize="11px"
                            color={FAINT}
                            fontFamily={FONT}
                            lineHeight="1.4"
                        >
                            {helper}
                        </Text>
                    )}
                </Box>
                <Box flex="1" minW="0">
                    {children}
                    <FieldError message={error} />
                </Box>
            </Flex>
        </FormControl>
    );
});

/* Real input that LOOKS like an input — visible border, clean focus */
const RealInput = memo(function RealInput({ ...props }) {
    return (
        <Input
            fontSize="13.5px"
            fontFamily={FONT}
            color={INK}
            h="38px"
            bg={SURFACE}
            border="1px solid"
            borderColor={BORDER_INPUT}
            borderRadius="8px"
            px="12px"
            _placeholder={{ color: FAINT, fontSize: '13px' }}
            _hover={{ borderColor: '#C5D0DF' }}
            _focusVisible={{
                borderColor: NAVY,
                boxShadow: `0 0 0 3px ${CYAN}77`,
                outline: 'none',
            }}
            transition="border-color 0.15s ease, box-shadow 0.15s ease"
            {...props}
        />
    );
});

/* Read-only display — looks like a styled label, not an input */
const ReadOnlyValue = memo(function ReadOnlyValue({ children, icon }) {
    return (
        <Flex
            align="center"
            gap="8px"
            h="38px"
            px="12px"
            bg={SURFACE_ALT}
            border="1px solid"
            borderColor={BORDER}
            borderRadius="8px"
            color={MUTED}
            fontSize="13.5px"
            fontFamily={FONT}
        >
            {icon && <Icon as={icon} color={FAINT} fontSize="14px" />}
            <Text noOfLines={1}>{children || '—'}</Text>
        </Flex>
    );
});

/* ─────────────────────────────────────────────────────────────
   AVATAR UPLOAD — more compact, side-by-side on desktop
   ───────────────────────────────────────────────────────────── */

const AvatarUpload = ({ imageUrl, onChange, agentId }) => {
    const inputRef = useRef(null);
    const [uploading, setUploading] = useState(false);

    const handleClick = () => inputRef.current?.click();

    const handleFileUpload = async (event) => {
        const file = event.target.files?.[0];
        if (!file) return;
        event.target.value = '';
        if (file.size > 5 * 1024 * 1024) {
            toast.error('Image too large. Maximum size is 5MB.');
            return;
        }
        if (!file.type.startsWith('image/')) {
            toast.error('Please choose an image file.');
            return;
        }
        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', 'o5dxfulx');
        setUploading(true);
        try {
            const response = await axios.post(
                'https://api.cloudinary.com/v1_1/tajiri/image/upload',
                formData,
            );
            const url = response?.data?.secure_url || response?.data?.url;
            if (!url) throw new Error('Upload returned no URL');
            onChange(url);
            toast.success('Photo updated');
        } catch (error) {
            console.error('Image upload failed:', error);
            toast.error('Could not upload photo. Please try again.');
        } finally {
            setUploading(false);
        }
    };

    return (
        <Flex
            align="center"
            gap="16px"
            p="14px"
            bg={SURFACE}
            border="1px solid"
            borderColor={BORDER}
            borderRadius="10px"
            mb="20px"
        >
            <Box position="relative" flexShrink={0}>
                <Image
                    src={imageUrl || ImagePlaceholder}
                    w="60px"
                    h="60px"
                    borderRadius="50%"
                    objectFit="cover"
                    border="2px solid"
                    borderColor={SURFACE_ALT}
                />
                {uploading && (
                    <Box
                        position="absolute"
                        inset="0"
                        bg="rgba(15,41,64,0.55)"
                        borderRadius="50%"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Text fontSize="8px" color="white" fontWeight="800">…</Text>
                    </Box>
                )}
            </Box>

            <Box flex="1" minW="0">
                <Text
                    fontSize="10.5px"
                    color={FAINT}
                    fontWeight="700"
                    letterSpacing="0.06em"
                    textTransform="uppercase"
                    mb="2px"
                >
                    Agent ID
                </Text>
                <Text
                    fontSize="14px"
                    color={INK}
                    fontWeight="800"
                    fontFamily={FONT}
                    noOfLines={1}
                >
                    {agentId || '—'}
                </Text>
            </Box>

            <Button
                onClick={handleClick}
                isLoading={uploading}
                bg={SURFACE_ALT}
                color={NAVY}
                fontWeight="700"
                fontSize="11.5px"
                fontFamily={FONT}
                h="32px"
                px="12px"
                borderRadius="8px"
                border="1px solid"
                borderColor={BORDER}
                leftIcon={<Icon as={AiOutlineCamera} fontSize="14px" />}
                _hover={{ bg: CYAN, borderColor: NAVY }}
                flexShrink={0}
            >
                Change
            </Button>

            <Input
                ref={inputRef}
                type="file"
                onChange={handleFileUpload}
                accept="image/*"
                display="none"
            />
        </Flex>
    );
};

/* ─────────────────────────────────────────────────────────────
   FORM BODY
   ───────────────────────────────────────────────────────────── */

const ProfileFormBody = ({
    accountType, email, profileImage, setProfileImage, agentId,
    currencies, currentCurrency, onCurrencyChange,
    isSubmitting,
}) => {
    const {
        values, errors, touched,
        handleChange, handleBlur, setFieldValue, setFieldTouched,
        dirty, handleSubmit,
    } = useFormikContext();

    const countries = useGetCountries();

    const selectedCountryIso = useMemo(() => {
        if (!countries) return null;
        return countries.find((c) => c.name === values.country)?.isoCode || null;
    }, [countries, values.country]);

    const states = useGetStatesByCountryId(selectedCountryIso);

    const selectedStateIso = useMemo(() => {
        if (!states) return null;
        return states.find((s) => s.name === values.state)?.isoCode || null;
    }, [states, values.state]);

    const cities = useGetCitiesByStateId(selectedStateIso, selectedCountryIso);

    const countryOptions = useMemo(
        () => (countries || []).map((c) => ({ label: c.name, value: c.name })),
        [countries]
    );
    const stateOptions = useMemo(
        () => (states || []).map((s) => ({ label: s.name, value: s.name })),
        [states]
    );
    const cityOptions = useMemo(
        () => (cities || []).map((c) => ({ label: c.name, value: c.name })),
        [cities]
    );

    const handleSelectChange = (fieldName, e) => {
        try {
            const parsed = JSON.parse(e.target.value);
            setFieldValue(fieldName, parsed.value || parsed.label);
            setFieldTouched(fieldName, true);
            if (fieldName === 'country') {
                setFieldValue('state', '');
                setFieldValue('city', '');
            }
            if (fieldName === 'state') {
                setFieldValue('city', '');
            }
        } catch {
            setFieldValue(fieldName, e.target.value);
            setFieldTouched(fieldName, true);
        }
    };

    /* Capitalize first letter for display fields like accountType */
    const titleCase = (s) =>
        s && typeof s === 'string'
            ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
            : '—';

    return (
        <form onSubmit={handleSubmit}>
            <DirtyFormGuard when={dirty && !isSubmitting} />

            <AvatarUpload
                imageUrl={profileImage}
                onChange={setProfileImage}
                agentId={agentId}
            />

            <Box bg={SURFACE} border="1px solid" borderColor={BORDER} borderRadius="10px" p={{ base: '16px', md: '20px 24px' }}>

                {/* ACCOUNT (single row) */}
                <SectionHeader isFirst>Account</SectionHeader>
                <FieldRow label="Account type">
                    <ReadOnlyValue>{titleCase(accountType)}</ReadOnlyValue>
                </FieldRow>

                {/* PERSONAL INFORMATION */}
                <SectionHeader>Personal information</SectionHeader>

                <FieldRow
                    label="First name"
                    error={touched.firstName && errors.firstName}
                >
                    <RealInput
                        name="firstName"
                        placeholder="Enter first name"
                        value={values.firstName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                </FieldRow>

                <FieldRow
                    label="Middle name"
                    error={touched.middleName && errors.middleName}
                >
                    <RealInput
                        name="middleName"
                        placeholder="Enter middle name (optional)"
                        value={values.middleName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                </FieldRow>

                <FieldRow
                    label="Last name"
                    error={touched.lastName && errors.lastName}
                >
                    <RealInput
                        name="lastName"
                        placeholder="Enter last name"
                        value={values.lastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                </FieldRow>

                <FieldRow
                    label="Gender"
                    error={touched.gender && errors.gender}
                >
                    <RadioGroup
                        value={values.gender || ''}
                        onChange={(v) => setFieldValue('gender', v)}
                    >
                        <Stack direction="row" spacing="20px" pt="9px">
                            <Radio value="Male" colorScheme="blue" size="md">
                                <Text fontSize="13px" fontFamily={FONT} color={INK}>Male</Text>
                            </Radio>
                            <Radio value="Female" colorScheme="blue" size="md">
                                <Text fontSize="13px" fontFamily={FONT} color={INK}>Female</Text>
                            </Radio>
                        </Stack>
                    </RadioGroup>
                </FieldRow>

                <FieldRow
                    label="Date of birth"
                    error={touched.dateOfBirth && errors.dateOfBirth}
                >
                    <RealInput
                        type="date"
                        name="dateOfBirth"
                        value={values.dateOfBirth}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        maxW={{ md: '220px' }}
                    />
                </FieldRow>

                {/* CONTACT INFORMATION */}
                <SectionHeader>Contact information</SectionHeader>

                <FieldRow
                    label="Phone number"
                    error={touched.phone && errors.phone}
                >
                    <RealInput
                        type="tel"
                        inputMode="tel"
                        name="phone"
                        placeholder="Enter phone number"
                        value={values.phone}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                </FieldRow>

                <FieldRow label="Email" helper="Verified email cannot be changed">
                    <ReadOnlyValue icon={AiOutlineMail}>{email}</ReadOnlyValue>
                </FieldRow>

                {/* LOCATION DETAILS */}
                <SectionHeader>Location details</SectionHeader>

                <FieldRow
                    label="Country"
                    error={touched.country && errors.country}
                >
                    <CustomSelect
                        name="country"
                        placeholder="Select country"
                        options={countryOptions}
                        value={
                            values.country
                                ? JSON.stringify({
                                    label: values.country,
                                    value: values.country,
                                  })
                                : ''
                        }
                        onChange={(e) => handleSelectChange('country', e)}
                        disabled={countryOptions.length === 0}
                        size="md"
                        h="38px"
                        fontSize="13.5px"
                        bg={SURFACE}
                        borderColor={BORDER_INPUT}
                        borderRadius="8px"
                        _hover={{ borderColor: '#C5D0DF' }}
                        _focus={{ borderColor: NAVY, boxShadow: `0 0 0 3px ${CYAN}77` }}
                    />
                </FieldRow>

                <FieldRow
                    label="State"
                    error={touched.state && errors.state}
                >
                    <CustomSelect
                        name="state"
                        placeholder="Select state"
                        options={stateOptions}
                        value={
                            values.state
                                ? JSON.stringify({
                                    label: values.state,
                                    value: values.state,
                                  })
                                : ''
                        }
                        onChange={(e) => handleSelectChange('state', e)}
                        disabled={stateOptions.length === 0}
                        size="md"
                        h="38px"
                        fontSize="13.5px"
                        bg={SURFACE}
                        borderColor={BORDER_INPUT}
                        borderRadius="8px"
                        _hover={{ borderColor: '#C5D0DF' }}
                        _focus={{ borderColor: NAVY, boxShadow: `0 0 0 3px ${CYAN}77` }}
                    />
                </FieldRow>

                <FieldRow
                    label="City"
                    error={touched.city && errors.city}
                >
                    <CustomSelect
                        name="city"
                        placeholder="Select city"
                        options={cityOptions}
                        value={
                            values.city
                                ? JSON.stringify({
                                    label: values.city,
                                    value: values.city,
                                  })
                                : ''
                        }
                        onChange={(e) => handleSelectChange('city', e)}
                        disabled={cityOptions.length === 0}
                        size="md"
                        h="38px"
                        fontSize="13.5px"
                        bg={SURFACE}
                        borderColor={BORDER_INPUT}
                        borderRadius="8px"
                        _hover={{ borderColor: '#C5D0DF' }}
                        _focus={{ borderColor: NAVY, boxShadow: `0 0 0 3px ${CYAN}77` }}
                    />
                </FieldRow>

                <FieldRow
                    label="Address"
                    error={touched.address && errors.address}
                >
                    <RealInput
                        name="address"
                        placeholder="Enter address"
                        value={values.address}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                </FieldRow>

                {/* INTERNATIONAL PREFERENCES */}
                <SectionHeader>Preferences</SectionHeader>

                <FieldRow label="Language">
                    <CustomSelect
                        name="language"
                        placeholder="Select language"
                        options={[
                            { label: 'English', value: 'English' },
                            { label: 'French',  value: 'French'  },
                            { label: 'Spanish', value: 'Spanish' },
                        ]}
                        value={
                            values.language
                                ? JSON.stringify({
                                    label: values.language,
                                    value: values.language,
                                  })
                                : ''
                        }
                        onChange={(e) => handleSelectChange('language', e)}
                        size="md"
                        h="38px"
                        fontSize="13.5px"
                        bg={SURFACE}
                        borderColor={BORDER_INPUT}
                        borderRadius="8px"
                        maxW={{ md: '260px' }}
                        _hover={{ borderColor: '#C5D0DF' }}
                        _focus={{ borderColor: NAVY, boxShadow: `0 0 0 3px ${CYAN}77` }}
                    />
                </FieldRow>

                <FieldRow label="Currency">
                    <CustomSelect
                        name="currency"
                        placeholder="Select currency"
                        options={
                            currencies?.length > 0
                                ? currencies.map((c) => ({
                                      label: c.symbol,
                                      value: c.symbol,
                                  }))
                                : []
                        }
                        value={
                            currentCurrency?.symbol
                                ? JSON.stringify({
                                    label: currentCurrency.symbol,
                                    value: currentCurrency.symbol,
                                  })
                                : ''
                        }
                        onChange={onCurrencyChange}
                        size="md"
                        h="38px"
                        fontSize="13.5px"
                        bg={SURFACE}
                        borderColor={BORDER_INPUT}
                        borderRadius="8px"
                        maxW={{ md: '160px' }}
                        disabled={!currencies?.length}
                        _hover={{ borderColor: '#C5D0DF' }}
                        _focus={{ borderColor: NAVY, boxShadow: `0 0 0 3px ${CYAN}77` }}
                    />
                </FieldRow>
            </Box>

            {/* SAVE BUTTON — sticky-feeling footer */}
            <Flex
                mt="20px"
                justify="flex-end"
                w="full"
                pt="12px"
                borderTop="1px solid"
                borderColor={BORDER}
            >
                <Button
                    type="submit"
                    bg={NAVY}
                    color="white"
                    _hover={{ bg: NAVY_DEEP }}
                    _active={{ bg: NAVY_DEEP }}
                    _disabled={{
                        bg: BORDER,
                        color: FAINT,
                        cursor: 'not-allowed',
                    }}
                    w={{ base: 'full', md: 'auto' }}
                    minW={{ md: '160px' }}
                    h="40px"
                    borderRadius="8px"
                    fontWeight="700"
                    fontSize="13px"
                    fontFamily={FONT}
                    isLoading={isSubmitting}
                    loadingText="Saving…"
                    isDisabled={isSubmitting || !dirty}
                >
                    Save changes
                </Button>
            </Flex>
        </form>
    );
};

/* ─────────────────────────────────────────────────────────────
   MAIN — USER PROFILE
   ───────────────────────────────────────────────────────────── */

const UserProfile = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const userLocationReducer = useSelector((state) => state.userLocationReducer);
    const verifyReducer       = useSelector((state) => state.verifyReducer);
    const profileReducer      = useSelector((state) => state.profileReducer);
    const currency            = useSelector((state) => state.currencyReducer.currenciesRates);
    const currencies          = useSelector((state) => state.currencyReducer.currencies);

    const { country }       = userLocationReducer;
    const { verifiedUser }  = verifyReducer;
    const { from, user }    = profileReducer;

    const { flattenedUser } = useGetUserDetails() || {};
    const details = flattenedUser?.attributes;
    const userDetails = transformAuthUser(user?.data?.user);

    const pageTitle = location.pathname.split('/').pop() === 'user'
        ? 'Personal profile'
        : 'Profile';

    const [hasSavedThisSession, setHasSavedThisSession] = useState(false);
    useEffect(() => {
        if (from === 'user' && hasSavedThisSession) {
            navigate('/dashboard/settings');
        }
    }, [from, hasSavedThisSession, navigate]);

    const initialImage =
        userDetails?.attributes?.user_imgage ||
        details?.user_information?.user_imgage ||
        details?.user_imgage ||
        '';
    const [profileImage, setProfileImage] = useState(initialImage);

    const initialValues = useMemo(() => ({
        firstName:    details?.user_information?.first_name  || details?.first_name  || '',
        lastName:     details?.user_information?.last_name   || details?.last_name   || '',
        middleName:   details?.user_information?.middle_name || details?.middle_name || '',
        phone:        details?.user_information?.phone       || details?.phone       || '',
        address:      details?.user_information?.address     || details?.address     || '',
        dateOfBirth:  details?.user_information?.date_of_birth || details?.date_of_birth || '',
        gender:       details?.user_information?.gender      || details?.gender      || '',
        country:      country || details?.user_information?.country || details?.country || '',
        state:        details?.user_information?.state || details?.state || '',
        city:         details?.user_information?.city  || details?.city  || '',
        language:     'English',
    }), [details, country]);

    const handleCurrencyChange = useCallback((e) => {
        try {
            const parsed = JSON.parse(e.target.value);
            const symbol = parsed.value || parsed.label;
            dispatch(setCurrencyValue(symbol));
            const rates = currencies?.find((c) => c.symbol === symbol);
            if (rates) {
                dispatch(setCurrenciesRates(rates));
            }
        } catch (err) {
            console.error('Currency change failed:', err);
        }
    }, [dispatch, currencies]);

    const handleSubmit = useCallback(async (values, { setSubmitting, resetForm }) => {
        const payload = {
            first_name:    values.firstName,
            last_name:     values.lastName,
            middle_name:   values.middleName,
            location:      values.country,
            language:      values.language,
            phone:         values.phone,
            address:       values.address,
            country:       values.country,
            state:         values.state,
            city:          values.city,
            user_imgage:   profileImage,
            currency:      currency?.symbol,
            date_of_birth: values.dateOfBirth,
            gender:        values.gender,
        };

        try {
            await dispatch(update_profile(payload, 'user'));
            setHasSavedThisSession(true);
            resetForm({ values });
        } catch (error) {
            console.error('Save failed:', error);
        } finally {
            setSubmitting(false);
        }
    }, [dispatch, profileImage, currency]);

    return (
        <ProfileConatiner>
            <Box
                maxW="780px"
                mx="auto"
                w="full"
                px={{ base: '12px', md: '20px' }}
                py={{ base: '8px', md: '12px' }}
                fontFamily={FONT}
            >
                {/* HEADER */}
                <HStack
                    spacing="8px"
                    align="center"
                    mb="14px"
                >
                    <Button
                        onClick={() => navigate(-1)}
                        variant="ghost"
                        size="sm"
                        h="32px"
                        w="32px"
                        minW="32px"
                        p="0"
                        borderRadius="7px"
                        color={MUTED}
                        _hover={{ bg: SURFACE_ALT, color: NAVY }}
                        _focusVisible={{
                            outline: `2px solid ${NAVY}`,
                            outlineOffset: '2px',
                        }}
                        aria-label="Go back"
                    >
                        <BackArrowIcon />
                    </Button>
                    <Heading
                        as="h1"
                        fontSize={{ base: '17px', md: '19px' }}
                        fontWeight="800"
                        color={INK}
                        fontFamily={FONT}
                        letterSpacing="-0.02em"
                    >
                        {pageTitle}
                    </Heading>
                </HStack>

                {/* FORM */}
                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    validationSchema={profileSchema}
                    onSubmit={handleSubmit}
                >
                    {({ isSubmitting }) => (
                        <ProfileFormBody
                            accountType={details?.account_types}
                            email={verifiedUser?.data?.user?.email}
                            profileImage={profileImage}
                            setProfileImage={setProfileImage}
                            agentId={details?.agent_id}
                            currencies={currencies}
                            currentCurrency={currency}
                            onCurrencyChange={handleCurrencyChange}
                            isSubmitting={isSubmitting}
                        />
                    )}
                </Formik>
            </Box>
        </ProfileConatiner>
    );
};

/* Named export — used by src/pages/dashboard/Settings.js for chevron-right icon */
export const right = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9 18L15 12L9 6"
            stroke="#090A0A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default UserProfile;